import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { map } from 'rxjs/operators';
import { PlatformService } from 'src/app/platform.service';
import { DataService } from 'src/app/services/data.service';
import { DisclaimersService } from 'src/app/services/disclaimers.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import {GetLockerPage} from '../../modals/get-locker/get-locker.page'
import { LanguageService } from 'src/app/services/language.service';
@Component({
  selector: 'app-lockers',
  templateUrl: './lockers.page.html',
  styleUrls: ['./lockers.page.scss'],
})
export class LockersPage implements OnDestroy {
  subscriptionEvent;
  loaded=false;
  searchItem;
  lockers = {};
  width = window.innerWidth;
  
  constructor(
    public disclaimerSRV:DisclaimersService,
    public platformSRV:PlatformService,
    private errorSRV:ErrorHandlerService,
    public modalController: ModalController,
    private router: Router,
    public dataService: DataService
  ) {}
  
  
  async getLocker(areaID){
    const desktopModal = await this.modalController.create({
      component: GetLockerPage,
      breakpoints: [0.5, 0.8,1],
     
      cssClass: 'modal-desktop-long',
      componentProps:{
        areaID
      }
     
    });
    const mobileModal = await this.modalController.create({
      component: GetLockerPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1,
      cssClass:"modal-mobile-normal",
      componentProps:{
        areaID
      }
     
    })
    const tabletModal = await this.modalController.create({
      component: GetLockerPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1, 
      cssClass:"modal-tablet-normal",
      componentProps:{
        areaID
      }
     
    })
    var modal = await this.dataService.getModalType(mobileModal, tabletModal, desktopModal)
    modal.present()
    
    
    
  }
  loadLockers(){
   
    this.dataService.getData('lockers')
    .subscribe({
      next:data=>{
        if(data['status']=="success"){
          data['buildings']=Object.values(data['buildings'])
          data['buildings'].forEach(element => {
           element['Areas'].forEach(element => {
            element['AreaLockerType']=data['lockerWindowTypes'][ element['AreaLockerType']]
           });
         });
         
         this.loaded=true
        this.lockers = data;}
         else {
           this.ngOnDestroy()
           
           
         }
      },
      error:err=>{
        this.errorSRV.displayErrorMessage(err,true)
        this.ngOnDestroy()
      }
      
    });
  }
  ionViewDidEnter() {
    var disclaimer;
    disclaimer= this.disclaimerSRV.disclaimers.find(disclaimer=>disclaimer['data_trigger']=='lockers-loaded'&& disclaimer['locale']==this.dataService.selected )
    
   
    
    
      if(disclaimer && disclaimer['active']){
        
        this.dataService.createAndOpenModal(disclaimer).then(data=>{
         if(data){
          this.proceed()
         }
          
        })
        
      } else {
        
       this.proceed()
        
        
      }
    
    
  }
  proceed(){
      
      this.subscriptionEvent=this.dataService.isAuthenticated.subscribe(isLoggedIn=>{
        if(isLoggedIn){
         
          this.loadLockers();
        } else {
          this.loaded=false
          this.lockers={}
          this.ngOnDestroy()
        }
      })
     
    
  }
  ngOnDestroy() {
    if(this.subscriptionEvent){
     
      this.subscriptionEvent.unsubscribe()
    }
    
    
     
   }
}
